import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router';
import ReadPane from './components/read-pane/ReadPane';
import SelectClassification from './components/select-classification/SelectClassification';
import Alerts from './components/alerts/Alerts';
import { appService } from './services/appService';
import Disabled from './components/disabled/Disabled';
import PortionMarkDisabled from './components/disabled/PortionMarkDisabled';
import FailOpenCloseAlert from './components/alerts/FailOpenCloseAlert';
import CustomActionFailure from './components/alerts/CustomActionFailure';

const App = () => {
    const isPlatformEnabled = appService.isPlatformEnabled();
    const isPortionMarkingEnabled = appService.isPortionMarkingEnabled();
    return (
        <div>
            <Routes>
                <Route path="/read" element={isPlatformEnabled ? <ReadPane /> : <Disabled />} />
                <Route
                    path="/select-classification"
                    element={isPlatformEnabled ? <SelectClassification /> : <Disabled />}
                />
                <Route
                    path="/select-portionMark"
                    element={(() => {
                        if (!isPlatformEnabled) return <Disabled />;
                        if (!isPortionMarkingEnabled) return <PortionMarkDisabled />;
                        return <SelectClassification />;
                    })()}
                />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/failOpenCloseAlert" element={<FailOpenCloseAlert />} />
                <Route path="/customActionFailure" element={<CustomActionFailure />} />
            </Routes>
        </div>
    );
};

export default App;
